import { SvgIcon } from "@mui/material"

import { ReactComponent as HorizontalSigning } from "./HorizontalSigning-icon.svg"

export const HorizontalSigningIcon = (props) => {
    return (
        <SvgIcon component={HorizontalSigning} inheritViewBox {...props} />
    )
}
